import {
    LocalizationService,
    NotifyService,
} from 'abp-ng2-module';
import { Injector } from '@angular/core';
import { SharedAppConsts } from '../AppConsts';

declare var abp: any;

export abstract class AppServiceBase {
    //#region localizationSourceName
    private _localizationSourceName: string;
    set localizationSourceName(values: string) {
        this._localizationSourceName = values;
    }
    get localizationSourceName(): string {
        return this._localizationSourceName;
    }
    //#endregion

    localization: LocalizationService;
    notify: NotifyService;

    constructor(injector: Injector) {
        this.localization = injector.get(LocalizationService);
        this.notify = injector.get(NotifyService);

        const AppConsts = SharedAppConsts.instance();
        this.localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
       
    }

    flattenDeep(array) {
        return array.reduce((acc, val) =>
            Array.isArray(val) ?
                acc.concat(this.flattenDeep(val)) :
                acc.concat(val),
            []);
    }

    l(key: string, ...args: any[]): string {
        args.unshift(key);
        args.unshift(this.localizationSourceName);
        return this.ls.apply(this, args);
    }

    ls(sourcename: string, key: string, ...args: any[]): string {
        let localizedText = this.localization.localize(key, sourcename);

        if (!localizedText) {
            localizedText = key;
        }

        if (!args || !args.length) {
            return localizedText;
        }

        args.unshift(localizedText);
        return abp.utils.formatString.apply(this, this.flattenDeep(args));
    }

}
